import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const CARD_COLORS = [
  "bg-jiored1 border-jiored1",
  "bg-jioyellow50",
  "bg-jiogreen1",
  "bg-jiojbm50",
  "bg-jiojbmpurple",
  "bg-jioskyblue53",
];

export const Score = ({ activeIndex, setActiveIndex, count, status }) => {
  const divClassName =
    "flex flex-col p-2 px-4 justify-center rounded-xl cursor-pointer border-2 text-white";
  const activeDivClassName = "w-[24%] h-36";
  const inActiveDivClassName = "w-[19%] h-32";
  const stateParaClassName = "font-jio-var leading-[36px] mt-1";
  const countParaClassName = "font-bold text-6xl";

  return (
    <>
      <div className="rounded-3xl">
        <div className="flex gap-1 mb-2 items-center justify-center">
          <p className="mr-auto text-lg font-bold">
            Tickets Summary
          </p>
        </div>
        <div className="flex justify-center items-center gap-4 h-44 px-2">
          <div
            className={`${divClassName} bg-jioskyblue53 ${
              activeIndex === "total" ? activeDivClassName : inActiveDivClassName
            }`}
            onClick={() => setActiveIndex("total")}
          >
            <p className={stateParaClassName}>Total</p>
            <p className={countParaClassName}>{count.total ?? 0}</p>
          </div>

          {(status ?? []).map((s, i) => (
            <div
              key={s.value}
              className={`${divClassName} ${CARD_COLORS[i % CARD_COLORS.length]} ${
                activeIndex === s.value ? activeDivClassName : inActiveDivClassName
              }`}
              onClick={() => setActiveIndex(s.value)}
            >
              <p className={stateParaClassName}>{s.key}</p>
              <p className={countParaClassName}>{count[s.value] ?? 0}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
